import { header } from "../../../setup/settings/index"
import Logo from "./Logo"

export default function LogoDrawer() {
    if(!header.logoMobileDrawer)
    {
        return <Logo/>
    }
    else
    {
        return (
                <img className='imgLogo' src={header.logoMobileDrawer}></img>
            )
    }
}